import { render, staticRenderFns } from "./AuthorizationDeleteModal.vue?vue&type=template&id=48008eca&"
import script from "./AuthorizationDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./AuthorizationDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports